// extracted by mini-css-extract-plugin
export default {"snackbar":"styles_snackbar__wgkz8","actionButton":"styles_actionButton__-DOra","bone-skeleton":"styles_bone-skeleton__FaumY"};